<template>
  <div class="page-dialog">
    <el-form
      ref="productForm"
      label-position="right"
      :inline="true"
      size="mini"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="存货分类">
            <el-select
              v-model="conditions.chfl"
              placeholder="请选择"
              type="select"
              datasource="valuesource"
              clearable
              filterable
            >
              <el-option
                v-for="item in selectDataOptions['A0019']"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="品牌(BQ)：">
            <el-select
              v-model="conditions.brand_bq"
              placeholder="请选择"
              type="select"
              datasource="valuesource"
              clearable
            >
              <el-option
                v-for="item in selectDataOptions['A0018']"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品编码">
            <el-input v-model="conditions.product_id" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品描述">
            <el-input v-model="conditions.short" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tl">
        <el-button type="default" icon="el-icon-refresh-right" size="mini" @click="reset">重置</el-button>
        <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading" @click="queryData">查询</el-button>
      </el-row>
    </el-form>

    <div class="table-container">
      <TableCommon
        :show-header="false"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="400"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>

  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSelectProduct } from '@/api/common'
import { filterSapParams } from '@/utils/index'
export default {
  props: {
    queryParams: {
      type: Object,
      default: () => {
        return { customerCode: '' }
      }
    },
    isAuth: {
      type: Boolean,
      default: false
    },
    isRadio: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        chfl: '',
        brand_bq: '',
        product_id: '',
        short: '',
        partner: ''
      },
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 40 },
          {
            field: 'PRODUCT_ID',
            title: '产品编码',
            width: 180
          },
          {
            field: 'SHORT_TEXT',
            title: '产品描述',
            width: 400
          },
          {
            field: 'CHFL_D',
            title: '存货分类',
            width: 180
          },
          {
            field: 'BRAND_BQ_D',
            title: '品牌',
            width: 180
          },
          {
            field: 'NORMS',
            title: '规格型号',
            width: 200
          },
          {
            field: 'SHORT',
            title: '产品简称',
            width: 250
          },
          {
            field: 'BASE_UOM_TEXT',
            title: '单位',
            width: 80
          }
        ],
        data: []
      }
    }
  },
  computed: {},
  created() {
    // 品牌BQ
    this.getSelectDictDataOrigin('A0018')
    // 存货分类
    this.getSelectDictDataOrigin('A0019')
    if (!this.isRadio) {
      this.gridOptions.columns[0].type = 'checkbox'
      this.gridOptions.columns[0].field = 'checkbox'
    }
  },
  methods: {
    cellClick({ row }) {
      if (this.isRadio) {
        this.$refs.gridOptions.setRadioRow(row)
      } else {
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 查询
    async queryData() {
      if (this.isAuth && !this.queryParams.customerCode) {
        return this.$message.warning('请先选择客户！')
      }
      this.loading = true
      try {
        const params = { ...this.pagination, ...filterSapParams(this.conditions, { cp: ['product_id', 'short'] }) }
        params.partner = this.queryParams.customerCode
        if (this.queryParams.mode) {
          params.mode = this.queryParams.mode
          params.yxdy = this.queryParams?.yxdy || undefined
          params.zzfld000001 = this.queryParams?.zzfld000001 || undefined
        }
        const res = await apiSelectProduct(params)
        if (res?.MSGTYPE === 'S') {
          this.gridOptions.data = res.DATA
          this.pagination.totalCount = +res.TOTAL
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    reset() {
      this.conditions = {
        chfl: '',
        brand_bq: '',
        product_id: '',
        short: ''
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      if (this.isRadio) {
        const selectData = this.$refs.gridOptions.getRadioRecord()
        if (selectData) {
          selectData.productShortName = selectData.SHORT
          selectData.productCode = selectData.PRODUCT_ID
          selectData.description = selectData.SHORT_TEXT
          selectData.brandBqTextView = selectData.BRAND_BQ_D
          selectData.containerNum = selectData.CAPTY
        }
        return Promise.resolve(selectData)
      } else {
        const selectData = this.$refs.gridOptions.getCheckboxRecords()
        if (selectData.length) {
          selectData.forEach(item => {
            item.productShortName = item.SHORT
            item.productCode = item.PRODUCT_ID
            item.description = item.SHORT_TEXT
            item.brandBqTextView = item.BRAND_BQ_D
            item.containerNum = item.CAPTY
          })
        }
        return Promise.resolve(selectData)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/ProductSelect.vue